export class OrderEditConfirmationTextParams {
    constructor() {
        this.OrderTypeKey = '';
        this.Tif = null;
        this.Account = null;
        this.Instrument = null;
        this.IsCashMode = null;
        this.Cash = null;
        this.Quantity = null;
        this.Buy = null;
        this.PriceArray = [];
        this.SlTpText = '';
        this.PriceInOffset = null;
        this.ProductType = null;
        this.OrderType = null;
        this.RealTrStopPrice = null;
        this.LeverageValue = null;
        this.IsAllowOTHTrading = null;
        this.PlacedFrom = null;
        this.TotalFee = null;
        this.EstAvailableCash = null;
    }
}
